module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "add-event-modal fluid",
    attrs: {
      "dialog": "modal-x-small"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("New Product")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "selections wrapper"
  }, [_c('vue-select', {
    attrs: {
      "label": "name",
      "placeholder": "- Select product -",
      "value": _vm.newEvent.product.id,
      "options": _vm.products
    },
    model: {
      value: (_vm.newEventProduct),
      callback: function($$v) {
        _vm.newEventProduct = $$v
      },
      expression: "newEventProduct"
    }
  }), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "name",
      "placeholder": "- Select vehicle -",
      "value": _vm.newEvent.product.transport.id,
      "options": _vm.transports
    },
    model: {
      value: (_vm.newEventVehicle),
      callback: function($$v) {
        _vm.newEventVehicle = $$v
      },
      expression: "newEventVehicle"
    }
  })], 1), _vm._v(" "), (_vm.start && _vm.end) ? _c('div', {
    staticClass: "timestamps border-top-light border-bottom-light bold"
  }, [_c('div', {
    staticClass: "d-flex wrapper"
  }, [_c('div', {
    staticClass: "flex-all"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.start)))]), _vm._v(" "), (!_vm.start.isSame(_vm.end, 'day')) ? _c('span', [_vm._v("\n                            to " + _vm._s(_vm.formatDate(_vm.end)) + "\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex-all"
  }, [_c('label', [_vm._v("Time")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.start.format('HH:mm:ss')) + " - " + _vm._s(_vm.end.format('HH:mm:ss')) + "\n                    ")])])])]) : _c('div', {
    staticClass: "timestamps border-top-light border-bottom-light"
  }, [_c('div', {
    staticClass: "d-flex wrapper"
  }, [_c('div', [_c('label', [_vm._v("Starts")]), _vm._v(" "), _c('vue-datepicker', {
    attrs: {
      "value": _vm.newEventStartDate,
      "wrapper-class": "date-input",
      "monday-first": false,
      "required": true
    },
    on: {
      "selected": _vm.setEventStartDate
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Time")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "defaultTime": _vm.newEventStartTime
    },
    on: {
      "change": _vm.setEventStartTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex wrapper"
  }, [_c('div', [_c('label', [_vm._v("Ends")]), _vm._v(" "), _c('vue-datepicker', {
    attrs: {
      "value": _vm.newEventEndDate,
      "wrapper-class": "date-input",
      "monday-first": false,
      "required": true
    },
    on: {
      "selected": _vm.setEventEndDate
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Time")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "defaultTime": _vm.newEventEndTime
    },
    on: {
      "change": _vm.setEventEndTime
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('vue-select', {
    attrs: {
      "label": "name",
      "placeholder": "- Select location -",
      "value": _vm.newEvent.product.location.id,
      "options": _vm.locations
    },
    model: {
      value: (_vm.newEventLocation),
      callback: function($$v) {
        _vm.newEventLocation = $$v
      },
      expression: "newEventLocation"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Availability limit")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spotsTotal),
      expression: "spotsTotal"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Add capacity"
    },
    domProps: {
      "value": (_vm.spotsTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.spotsTotal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('label', {
    staticClass: "mt-2"
  }, [_c('checkbox', {
    on: {
      "input": _vm.setAllotment
    }
  }, [_vm._v("\n                            Set allotment\n                        ")])], 1)])])], 1), _vm._v(" "), (_vm.allotment) ? _c('div', {
    staticClass: "allotment border-top-light mt-2 pt-3 wrapper"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Allotment limit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spotsAllotted),
      expression: "spotsAllotted"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Add allotment"
    },
    domProps: {
      "value": (_vm.spotsAllotted)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.spotsAllotted = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Linked to")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "value": _vm.newEvent.linked,
      "searchable": false,
      "options": _vm.links
    },
    model: {
      value: (_vm.selectedLink),
      callback: function($$v) {
        _vm.selectedLink = $$v
      },
      expression: "selectedLink"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn yes wide flex-all",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-696cbee6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696cbee6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventAdd.vue
// module id = 918
// module chunks = 0